var video_viewer_default = {
  "video_player": "s2boE",
  "videoOverlay": "mqxxa",
  "video_container": "Gqzkd"
};
export {
  video_viewer_default as default
};
//# sourceMappingURL=video-viewer-scss.js.map
